












import exercises from "./afterClassExercises/index.vue";
import exercisesDetail from "./afterClassExercisesDetail/index.vue";
import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { mixin } from "@/mixin/tabPageInfoMixin";
@Component({
  components: {
    exercises,
    exercisesDetail,
  },
})
export default class extends Mixins(mixin) {
  activeName = "exercises";
  handleClick() {
    this.mixinSavePageInfo("afterClassExercisesTab", this.activeName);
  }
  created() {
    this.mixinGetPageInfo("afterClassExercisesTab");
  }
}
